import React, { useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import toast from 'react-hot-toast';
import {
  e2eConfigLogic_buildProviderResponseLogicObject,
  ProviderOfferLogicObjectI,
} from 'src/e2e-redesign/business-logic/e2e-configuration-object-logic';
import {
  E2eLogicObjectsWithAasoParams,
  e2eLogicUtils_getRoutingLogicObjects,
} from 'src/e2e-redesign/business-logic/e2e-logic-utils';
import SingleLogo from 'src/e2e-redesign/components/SingleLogo';
import ThemedCard from 'src/e2e-redesign/components/ThemedCard';
import {
  e2eLogic_getShowStatusIfExists,
  GroupedOfferI,
} from 'src/e2e-redesign/views/LenderResponses/logic/provider-response-logic';
import NewDumbNotOfferCard from 'src/e2e-redesign/views/LenderResponses/new-dumb-not-offer-card';
import { EcoaMessage } from 'src/e2e-redesign/views/LenderResponses/new-lender-response-table';
import { LendersI } from 'src/interfaces/lenders.interfaces';
import {
  ApplicationSubmissionStateDto,
  AppSubLenderResponseE,
  AppSubStatusE,
} from 'src/interfaces/submissions.interfaces';
import { parseHtml } from 'src/utils/general';

interface ResponseCardProps {
  // details: NotOffersI;
  groupedOffer: GroupedOfferI;
}

export default function NewHandleNotOfferCard(props: ResponseCardProps) {
  const { groupedOffer } = props;
  const details = groupedOffer.notOffers[0];
  const routingPackage: E2eLogicObjectsWithAasoParams = e2eLogicUtils_getRoutingLogicObjects();
  const e2eStore = routingPackage.e2eStore;
  const appConfig = e2eStore.app_configurations;
  const { params } = routingPackage;
  const { e2e_form_id, store_uuid, aaso_id } = params;
  const submissionDetails: ApplicationSubmissionStateDto = details.sub_details;
  const [offerLogicObj, setOfferLogicObj] = useState<ProviderOfferLogicObjectI>();
  const [showUpdateStatus, setShowUpdateStatus] = useState<boolean>(false);
  const [showEcoa, setShowEcoa] = useState<boolean>(false);
  const l: LendersI = details.lender;
  const lenderDisclosures = details.lender_disclosures;
  const addSubmission = routingPackage.e2eStore.addSubmission;
  if (!e2e_form_id || !store_uuid || !aaso_id) throw new Error('No key params');

  useEffect(() => {
    const showEcoaStatuses = [AppSubLenderResponseE.rejected, AppSubLenderResponseE.soft_decline];
    if (showEcoaStatuses.includes(submissionDetails.lender_response)) {
      setShowEcoa(true);
    } else {
      setShowEcoa(false);
    }
  }, [submissionDetails]);

  useEffect(() => {
    // handle update status
    const settings = e2eLogic_getShowStatusIfExists(appConfig?.laa_settings, l);

    if (!settings) return;
    const lenderResponses = settings?.on?.lender_responses;
    if (settings && lenderResponses) {
      if (settings?.enabled && lenderResponses) {
        // logic for showing Update Status
        const currentLenderResponse = submissionDetails.lender_response;
        if (lenderResponses.includes(currentLenderResponse)) {
          setShowUpdateStatus(true);
        } else {
          setShowUpdateStatus(false);
        }
      } else {
        setShowUpdateStatus(false);
      }
    }
  }, [appConfig?.laa_settings, submissionDetails.lender_response, l]);

  useEffect(() => {
    if (details) {
      const obj = e2eConfigLogic_buildProviderResponseLogicObject(details);
      if (obj) {
        setOfferLogicObj(obj);
      }
    }
  }, [details]);

  const getLenderLogo = () => {
    if (l.logo_url) {
      // R:TODO E2E P3 - see other note about how to handle lender logos
      // Go based on the lender object logo url
      return {
        src: l.logo_url,
        alt: l.name,
      };
    } else {
      // if no logo exists in lender object, use disclosures
      if (lenderDisclosures && lenderDisclosures?.length > 0) {
        const disc = lenderDisclosures.find((ld) => ld.logo.length > 0);
        if (disc) {
          return {
            src: disc.logo,
            alt: l.name,
          };
        }
      }
    }
    return false;
  };

  if (!offerLogicObj) return null;

  const lenderLogoDetails = getLenderLogo();

  const handleUpdateStatus = async () => {
    // TODO E2E P0 - handle proceed for synchrony logic - update status
    try {
      const settings = e2eLogic_getShowStatusIfExists(appConfig?.laa_settings, l);
      if (settings) {
        const submissionStates = settings?.on?.lender_responses;
        if (submissionStates) {
          addSubmission(routingPackage.params, [AppSubStatusE.lender_responded], Number(l.lender_id), true);
          const getSubs = routingPackage.e2eStore.getE2eSubmissions;
          getSubs(routingPackage.params.aaso_id, routingPackage.params.e2e_form_id);
          [3000, 8000, 15000, 25000, 40000].forEach((ms) =>
            setTimeout(() => getSubs(routingPackage.params.aaso_id, routingPackage.params.e2e_form_id), ms),
          );
        }
      }
    } catch (e) {
      toast.error(e.message);
    }
  };

  return (
    <NewDumbNotOfferCard
      groupedOffer={groupedOffer}
      submissionDetails={submissionDetails}
      lenderLogoDetails={lenderLogoDetails}
      handleUpdateStatus={handleUpdateStatus}
      showUpdateStatus={showUpdateStatus}
      showEcoa={showEcoa}
    />
  );
}
